import { Box, Stack, Container } from '@mui/material';

import { useAlert } from 'hooks';
import { clearCacheAndReload } from 'utils';

import { Button } from '../button';
import { Background } from '../background';

export const ErrorBoundaryView = ({
  error,
  onClick,
  dynamicImportError,
}: {
  error: string | null;
  onClick?: () => void;
  dynamicImportError?: boolean;
}) => {
  const { handleError } = useAlert();

  return (
    <Box
      sx={{ bgcolor: 'background.default' }}
      className="absolute top-0 left-0 z-2000 flex h-screen w-screen flex-col items-center justify-center gap-6 border-gray-400/40 shadow-lg"
    >
      <Background className="z-1" />
      <div className="relative z-2 flex h-full w-full flex-col overflow-y-auto py-6">
        <Container maxWidth="sm" component="main" className="my-auto shrink-0">
          <Stack
            sx={{
              p: 4,
              gap: 1,
              display: 'flex',
              borderRadius: 1,
              border: '1px solid',
              alignItems: 'center',
              flexDirection: 'column',
              backgroundColor: 'white',
            }}
          >
            <h4>
              {dynamicImportError
                ? 'New version of the app is available'
                : 'Something went wrong'}
            </h4>
            <div className="flex w-full flex-col gap-6">
              {error && !dynamicImportError && <p>Error: {error}</p>}

              <Button
                onClick={async () => {
                  try {
                    onClick?.();

                    await clearCacheAndReload();
                  } catch (error) {
                    handleError(error);
                  }
                }}
              >
                {dynamicImportError ? 'Get new version' : 'Clear cache'}
              </Button>
            </div>
          </Stack>
        </Container>
      </div>
    </Box>
  );
};
